import { useTranslate } from '@dreryk/react-common';
import { FormContent } from '@dreryk/react-components';

import { protectFeature } from '~libs.shared.system';

import { StyledFormSectionHeader } from '../../common/StyledFormSectionHeader';
import { patientPhoneNotificationTranslationKeys } from '../../translations';

import { PatientPhoneNotificationAppointmentCancellationToggleWithLoader } from './PatientPhoneNotificationAppointmentCancellationToggle';
import { PatientPhoneNotificationAppointmentCancellationTokenInConfirmationToggleWithLoader } from './PatientPhoneNotificationAppointmentCancellationTokenInConfirmationToggle';
import { PatientPhoneNotificationAppointmentCancellationTokenInReminderToggleWithLoader } from './PatientPhoneNotificationAppointmentCancellationTokenInReminderToggle';
import { PatientPhoneNotificationAppointmentConfirmationToggleWithLoader } from './PatientPhoneNotificationAppointmentConfirmationToggle';
import { PatientPhoneNotificationAppointmentReminderToggleWithLoader } from './PatientPhoneNotificationAppointmentReminderToggle';
import { PatientPhoneNotificationElectronicDocumentIssuedToggleWithLoader } from './PatientPhoneNotificationElectronicDocumentIssuedToggle';
import { PatientPhoneNotificationWaitlistProposedAppointmentResponseTokenToggleWithLoader } from './PatientPhoneNotificationWaitlistProposedAppointmentResponseTokenToggle';
import { PatientPhoneNotificationWaitlistProposedAppointmentToggleWithLoader } from './PatientPhoneNotificationWaitlistProposedAppointmentToggle';
import { PractitionerPhoneNotificationAppointmentCancellationToggleWithLoader } from './PractitionerPhoneNotificationAppointmentCancellationToggle';
import { PractitionerPhoneNotificationAppointmentConfirmationToggleWithLoader } from './PractitionerPhoneNotificationAppointmentConfirmationToggle';
import { StyledPatientPhoneNotificationForm } from './StyledPatientPhoneNotificationForm';
import { PatientPhoneNotificationVideoConsultationReminder } from './patientPhoneNotificationVideoConsultationReminder/PatientPhoneNotificationVideoConsultationReminder';

export const PatientPhoneNotificationForm = (): JSX.Element => {
   const translate = useTranslate();

   return (
      <StyledPatientPhoneNotificationForm>
         <FormContent testId={'patientPhoneNotification'}>
            <StyledFormSectionHeader>
               {translate(patientPhoneNotificationTranslationKeys.smsSettings)}
            </StyledFormSectionHeader>
            <PatientPhoneNotificationElectronicDocumentIssuedToggleWithLoader />
            <PatientPhoneNotificationAppointmentConfirmationToggleWithLoader />
            <PatientPhoneNotificationAppointmentCancellationTokenInConfirmationToggleWithLoader />
            <PatientPhoneNotificationAppointmentReminderToggleWithLoader />
            <PatientPhoneNotificationAppointmentCancellationTokenInReminderToggleWithLoader />
            {/* TODO DREGAB-27120 Zdjęcie flagi eksperymentalnej przy wprowadzeniu powiadomień SMS dla listy rezerwowej */}
            {protectFeature(
               'experimental',
               <>
                  <PatientPhoneNotificationWaitlistProposedAppointmentToggleWithLoader />
                  <PatientPhoneNotificationWaitlistProposedAppointmentResponseTokenToggleWithLoader />
               </>
            )}
            <PractitionerPhoneNotificationAppointmentConfirmationToggleWithLoader />
            <PractitionerPhoneNotificationAppointmentCancellationToggleWithLoader />
            <PatientPhoneNotificationAppointmentCancellationToggleWithLoader />

            {protectFeature('managingVideoConsultations', <PatientPhoneNotificationVideoConsultationReminder />)}
         </FormContent>
      </StyledPatientPhoneNotificationForm>
   );
};
